import './map/style.css';

import { useState } from 'react';
import { Map, APIProvider } from '@vis.gl/react-google-maps';

import { CustomAdvancedMarker } from './map/components/custom-advanced-marker/custom-advanced-marker';


const ProductListOnMap = ({ activities }: { activities: any[] }) => {
  const [openMarkerId, setOpenMarkerId] = useState<string | null>(null);

  return (
    <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY as string}>
      <div className="advanced-marker-example">
        <Map
          mapId={process.env.REACT_APP_GOOGLE_MAPS_ID as string}
          style={{ width: '100%', height: '100vh' }} // Changed from 100vw to 100%
          defaultCenter={{ lat: 41.0082, lng: 28.9784 }} // Istanbul coordinates
          defaultZoom={10} // Closer zoom for city level
          gestureHandling="greedy"
          disableDefaultUI
          onClick={() => setOpenMarkerId(null)}
        >
          {activities?.map((activity: any) => (
            <CustomAdvancedMarker
              key={activity._id || activity.id}
              activity={activity}
              openMarkerId={openMarkerId}
              setOpenMarkerId={setOpenMarkerId}
            />
          ))}
        </Map>
      </div>
    </APIProvider>
  );
};

export default ProductListOnMap;
